import React from "react";

import { Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";

import { dateFormatDayMonthYear } from "../../../utils/dateTimeFormats";
import { useMdxContent } from "../hooks";
import { type Insight } from "../types";

export const ExpertNote: React.FC<{ insight: Insight }> = ({ insight }) => {
  const expertNote = useMdxContent(insight?.expertNote?.note ?? "");

  if (!insight?.expertNote?.note) {
    return null;
  }

  return (
    <Stack
      sx={{
        mt: 3,
        mb: 3,
        borderLeft: "4px solid #D51A4E",
        paddingLeft: "24px",
      }}
    >
      <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 500 }}>
        Expert Notes
      </Typography>
      <Typography variant="body1">{expertNote}</Typography>
      <Typography variant="caption" color="text.secondary">
        {DateTime.fromJSDate(new Date(insight.expertNote.createdAt ?? "")).toFormat(dateFormatDayMonthYear)}
      </Typography>
    </Stack>
  );
};

export default ExpertNote;
